import { HLS_KR, SS } from '../../utils/playerConstants';
import storage from '../../components/DeviceStorage/DeviceStorage';

let deviceInfo =
    window.AndroidPlayerInterface && window.AndroidPlayerInterface.getDeviceInformation
        ? window.AndroidPlayerInterface.getDeviceInformation()
        : '{}';
deviceInfo = JSON.parse(deviceInfo);

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS];
supported_stream_types.live = [HLS_KR];
supported_stream_types.timeshift = [HLS_KR];

export default {
    appKey: storage.getItem('force_appkey')
        ? 'f22b3fd50036b7730063509e2f423393'
        : '66d1566a71dbaaf6cf65a5a8111d8043',
    appSubkey: 'n9108',
    // Request params
    device_category: 'stb',
    device_id: deviceInfo.device_id, // como obtener device id
    device_manufacturer: 'coship',
    device_model: 'N9108',
    device_name: deviceInfo.device_name || 'N9108', // como arman device Name
    device_so: deviceInfo.device_so || 'Android 9', // como obtener device_so
    device_type: storage.getItem('force_appkey') ? 'ptv' : 'ott',
    stream_type: 'smooth_streaming',
    appversion: deviceInfo.appversion || '503', // como obtener appversion
    firmwareversion: deviceInfo.firmwareversion || '001.999.999', // como obtener firmware version,
    useEpgPostals: true,
    akamai_id: 'Coship',
    nodetv: 'tv',
    akamai_mfwk: 'mfwkcoship-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/stbcoship9108/config.js